import { render, staticRenderFns } from "./ResultsGrid.vue?vue&type=template&id=f4cfa2f2&"
import script from "./ResultsGrid.vue?vue&type=script&lang=js&"
export * from "./ResultsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports